module.exports = __webpack_public_path__ + "static/img/sign-dark.58ba255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sign-dark.jpg
// module id = pS8x
// module chunks = 9